import { render, staticRenderFns } from "./EcommerceFinancialStatistics.vue?vue&type=template&id=3222a710&scoped=true&"
import script from "./EcommerceFinancialStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceFinancialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceFinancialStatistics.vue?vue&type=style&index=0&id=3222a710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3222a710",
  null
  
)

export default component.exports